
    import { Component, Vue } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import PrePlanForm from './pre-plan-manage.vue'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import DateUtils from '@/common/js/DateUtils'
    import moment from 'moment'

    // 下拉选项类型
    interface SelectOption {
        value: boolean | null;
        label: string;
    }

    // 查询参数模型 - 关键修正：isSelf 类型为 boolean | null，默认值为 false
    class PrePlanSearchRequest extends PageRequest {
        userId?: number; // 新增用户编码
        startDate?: Date;
        endDate?: Date;
        productInternalCode: string = '';
        logisticsNumber: string = '';
        boxBatchNumber: string = '';
        planNumber: string = '';
        shippingMark: string = '';
        isSelf: string = 'false'; // 默认选中 "否"
        storeId?: number | null;
        isProcessed?: boolean | null;
        productId: string = '';
    }

    // 列表数据结构
    interface PlanWarehouseStock {
        prePlanId: number;
        productId: number;
        productNums: number;
        logisticsNumber: string;
        productStatus?: number;
        boxNumber: number;
        inStockNumber: string;
    }
    interface PlanPackingDetail {
        packingPlanId: number;
        productId: number;
        boxNumber: number;
        productNums: number;
        creationTime: Date;
    }
    interface PackingPlanList {
        id: number;
        userCode: string;
        planNumber: string;
        creationTime: Date;
        remark: string;
        storeId: number;
        storeName: string;
        isSelf: boolean;
        isProcess: boolean;
        shippingMark: string;
        boxBatchNumber: string;
        planWarehouseStocks: PlanWarehouseStock[];
        planPackingDetails: PlanPackingDetail[];
    }

    @Component({
        name: "backpreplanmanager",
        components: { PrePlanForm }
    })
    export default class BackPrePlanManager extends AbpBase {
        modalShow: boolean = false;
        storeaddressList: Array<storeaddressInfo> = [];
        pagerequest: PrePlanSearchRequest = new PrePlanSearchRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        ProductStatus = Enums.getEnum(Enums.ProductStatus, true);

        // 下拉选项
        IsSelfOptions: any[] = [
            { value: '', label: '全部' },
            { value: 'true', label: '是' },
            { value: 'false', label: '否' }
        ];

        IsProcessedOptions: SelectOption[] = [
            { value: null, label: '全部' },
            { value: true, label: '是' },
            { value: false, label: '否' }
        ];

        // ======== 切换到 backpreplan ========
        get list(): PackingPlanList[] {
            return this.$store.state.backpreplan.list;
        }
        get loading(): boolean {
            return this.$store.state.backpreplan.loading;
        }
        get pageSize(): number {
            return this.$store.state.backpreplan.pageSize;
        }
        get totalCount(): number {
            return this.$store.state.backpreplan.totalCount;
        }
        get currentPage(): number {
            return this.$store.state.backpreplan.currentPage;
        }

        columns = [
            {
                title: '基本信息',
                width: 250,
                fixed: 'left',
                render: (h: any, params: any) => {
                    const row = params.row;
                    return h('div', [
                        h('h3', `计划单号：${row.planNumber || ''}`),
                        h('h3', `用户编码：${row.userCode || ''}`), // 新增用户编码显示
                        h('h3', `仓库名称：${row.storeName || ''}`),
                        h('h3', `是否自装箱：${row.isSelf ? '是' : '否'}`),
                        h('h3', `是否已处理：${row.isProcess ? '是' : '否'}`),
                        h('h3', `创建时间：${DateUtils.formatLongDate(new Date(row.creationTime))}`)
                    ]);
                }
            },
            {
                title: '装箱信息',
                width: 200,
                render: (h: any, params: any) => {
                    const row = params.row;
                    return h('div', [
                        h('h3', `唛头：${row.shippingMark || ''}`),
                        h('h3', `装箱批次号：${row.boxBatchNumber || ''}`),
                        h('h3', `备注：${row.remark || '无'}`)
                    ]);
                }
            },
            {
                title: '入库单记录',
                width: 720,
                render: (h: any, params: any) => {
                    const row = params.row;
                    const stockList = row.planWarehouseStocks || [];
                    if (stockList.length === 0) {
                        return h('span', '暂无入库单记录');
                    }
                    const tableHeader = ['入库单号', '物流单号', '产品内码', '产品数量', '装箱数量', '状态'];
                    return h('div', { style: { overflow: 'auto' } }, [
                        h('table', { style: { width: '100%', borderCollapse: 'collapse', fontSize: '12px' } }, [
                            h('thead', [
                                h('tr', { style: { background: '#f5f5f5' } },
                                    tableHeader.map((header, idx) => {
                                        let thStyle: any = { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', whiteSpace: 'nowrap' };
                                        switch (idx) {
                                            case 0: thStyle.width = '180px'; break;
                                            case 1: thStyle.width = '180px'; break;
                                            case 3: thStyle.width = '60px'; break;
                                            case 4: thStyle.width = '60px'; break;
                                            default: thStyle.width = '100px'; break;
                                        }
                                        return h('th', { key: idx, style: thStyle }, header);
                                    })
                                )
                            ]),
                            h('tbody',
                                stockList.map((stock: any, index: number) => {
                                    // 不使用 ?. 语法
                                    let statusText = '';
                                    const statusItem = this.ProductStatus.find(item => item.value === stock.productStatus);
                                    if (statusItem) {
                                        statusText = statusItem.name;
                                    }
                                    const productNums = Number(stock.productNums) || 0;
                                    const boxNumber = Number(stock.boxNumber) || 0;
                                    const isNumsMismatch = productNums !== boxNumber;
                                    const boxNumberTdStyle = {
                                        border: '1px solid #eee',
                                        padding: '8px 5px',
                                        textAlign: 'center',
                                        color: isNumsMismatch ? 'red' : 'inherit',
                                        fontWeight: isNumsMismatch ? 'bold' : 'normal'
                                    };
                                    return h('tr', { key: index }, [
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, stock.inStockNumber || ''),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, stock.logisticsNumber || ''),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, stock.productId || ''),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, `${productNums}`),
                                        h('td', { style: boxNumberTdStyle }, `${boxNumber}`),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, statusText)
                                    ]);
                                })
                            )
                        ])
                    ]);
                }
            },
            {
                title: '装箱记录',
                width: 440,
                render: (h: any, params: any) => {
                    const row = params.row;
                    const packingList = row.planPackingDetails || [];
                    if (packingList.length === 0) {
                        return h('span', '暂无装箱记录');
                    }
                    const packingHeader = ['箱号', '产品ID', '装箱数量', '装箱时间'];
                    return h('div', { style: { overflow: 'auto' } }, [
                        h('table', { style: { width: '100%', borderCollapse: 'collapse', fontSize: '12px' } }, [
                            h('thead', [
                                h('tr', { style: { background: '#f5f5f5' } },
                                    packingHeader.map((header, idx) => {
                                        let thStyle: any = { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', whiteSpace: 'nowrap' };
                                        switch (idx) {
                                            case 0: thStyle.width = '50px'; break;
                                            case 1: thStyle.width = '100px'; break;
                                            case 2: thStyle.width = '80px'; break;
                                            case 3: thStyle.width = '170px'; break;
                                            default: thStyle.width = '100px'; break;
                                        }
                                        return h('th', { key: idx, style: thStyle }, header);
                                    })
                                )
                            ]),
                            h('tbody',
                                packingList.map((packing: any, index: number) => {
                                    const boxNum = packing.boxNumber || 0;
                                    const productId = packing.productId || 0;
                                    const productNums = packing.productNums || 0;
                                    const createTime = packing.creationTime
                                        ? DateUtils.formatLongDate(new Date(packing.creationTime))
                                        : '';
                                    return h('tr', { key: index }, [
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, boxNum),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, productId),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, productNums),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, createTime)
                                    ]);
                                })
                            )
                        ])
                    ]);
                }
            },
            {
                title: '操作',
                width: 180,
                fixed: 'right',
                render: (h: any, params: any) => {
                    const row = params.row;
                    // 如果是自装箱，不显示任何按钮
                    if (row.isSelf) {
                        return h('span', '');
                    }
                    // 不是自装箱，只显示编辑按钮
                    return h('div', [
                        h('Button', {
                            props: { type: 'primary', size: 'small', icon: 'ios-create' },
                            style: { marginRight: '10px', marginTop: '5px', width: '80px' },
                            on: { click: () => this.modify(row) }
                        }, "编辑")
                    ]);
                }
            }
        ];

        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            });
            const allStoreOption: storeaddressInfo = { id: null, storeName: "全部" } as storeaddressInfo;
            this.storeaddressList = [allStoreOption, ...this.$store.state.backstoreaddress.list];
        }

        async modify(data: any) {
            this.$store.commit('backpreplan/setModel', data);
            this.modalShow = true;
        }

        pageChange(page: number) {
            this.$store.commit('backpreplan/setCurrentPage', page);
            this.getpage();
        }

        pagesizeChange(pagesize: number) {
            this.$store.commit('backpreplan/setPageSize', pagesize);
            this.getpage();
        }

        async searchPage() {
            this.$store.commit('backpreplan/setCurrentPage', 1);
            this.getpage();
        }

        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            if (this.creationTime.length > 0) {
                this.pagerequest.startDate = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endDate = this.creationTime[1];
            }
            await this.$store.dispatch({
                type: 'backpreplan/getAll',
                data: this.pagerequest
            });
        }

        async created() {
            await this.getData();
            this.getpage();
        }
    }
